import { createContext, useContext } from 'react';
import { UseAuth } from '@packages/provider/module/auth/auth-hook.ts';

export const AuthContext = createContext<UseAuth | undefined>(undefined);

export function useAuth(): UseAuth {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuthContext must be used within a AuthContextProvider');
  }

  return context;
}
